module.exports = __webpack_public_path__ + "static/media/banner.8c148166.svg";